import { writable } from 'svelte/store'

const urlbase = window.location.origin;

export const databases = writable([]);
export const filteredDatabases = writable([]);
export const letterFilteredDatabases = writable([]);

export const isLoadingDatabases = writable(false);

export const getDatabases = () => {
    isLoadingDatabases.set(true);

    return fetch(`${urlbase}/library/wp-json/wp/v2/databases`)
        .then(response => response.json())
        .then(data => {
            console.log('getDatabases response:', data);
            databases.set(data); // update databases store with fetched data
            isLoadingDatabases.set(false);
            return data;
        })
        .catch(error => {
            console.error('getDatabases error:', error);
            databases.set([]); // update databases store with empty array
            isLoadingDatabases.set(false);
            return [];
        });
};

// Fetch the initial list of databases
getDatabases();
